<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create IncomeCategory" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-income-category-form [incomeCategory]="incomeCategory" *ngIf="incomeCategory"></app-income-category-form>
        </form>
      </div>
    </section>
  </div>
</div>


